import { jsx as n } from "react/jsx-runtime";
import { cn as m } from "../../utils.js";
const o = ({
  className: i,
  children: l
}) => /* @__PURE__ */ n("div", { className: m("placebo-container", i), children: /* @__PURE__ */ n("div", { className: "min-w-full p-0 md:min-w-[calc(960px_-_20px_*_4)] lg:min-w-full", children: l }) });
export {
  o as Container
};
